bcp-fetch-price-data {
  width: 100%;

  .product-item {
    .product-grid-container {
      padding: 5px;
    }

    table td {
      padding-left: 10px !important;
    }
  }

  ul {
    margin-bottom: 25px;
  }

  .wishlist-add-to-wishlist-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wishlist-add-to-wishlist-btn span {
    line-height: 1.2em;
  }

  .wishlist-add-to-wishlist-btn svg {
    flex: 0 0 auto;
    margin-left: 10px;
  }
}
